import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

const VisualBasicLanguageIcon = createSvgIcon({
  svg: ({ classes }) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2048 2048" className={classes.svg}>
      <path d="M543 1512q9-58 29-115L929 384h159L621 1664H458L0 384h165l349 1015q10 28 16 56t13 57zm1220-528q64 8 117 32t90 65 57 95 21 120q0 89-34 157t-91 115-132 71-158 25h-373V384h364q69 0 133 17t115 52 81 91 31 133q0 110-58 190t-163 113v4zm-353-51h153q55 0 103-13t84-40 56-71 21-103q0-55-20-91t-54-57-78-29-93-9h-172v413zm203 595q56 0 106-13t89-41 60-72 23-107q0-69-26-113t-70-69-99-35-114-10h-172v460h203z" />
    </svg>
  ),
  displayName: 'VisualBasicLanguageIcon',
});

export default VisualBasicLanguageIcon;
